module.exports = __webpack_public_path__ + "static/media/redeem_active.7dc5473c.svg";